import { BaseService } from '@ahoy/aquarium/dist/core/services/ServiceBase';
import { eventBus } from '@ahoy/aquarium/dist/core/EventBus';
import { Events } from '@ahoy/aquarium/dist/events/app-events';
import { ApiService } from '@APP/services/api-service';
import { WebSectionTrackingData } from '@FLAVOR/../../common/types';
import { PopupService } from '@APP/services/popup-service';

type Deps = {
  apiService: ApiService;
  popupService: PopupService;
};

type MailOptions = {
  mailType: string;
  isLockScreen: boolean;
  operation: string;
  qId: string;
};

export class MailService extends BaseService<Deps> {
  static serviceName: string = 'mailService';

  public async sendMail({ mailType, isLockScreen, operation, qId }: MailOptions) {
    if (!qId) throw 'no qId';

    if (isLockScreen) this.deps.apiService.lock();
    /** Send mails */
    const mailResponse = await this.deps.apiService.http('/mail?mailType=' + mailType + '&qId=' + qId);
    if (isLockScreen) this.deps.apiService.unlock();

    if (mailResponse === 'function executed successfully') {
      console.log(mailResponse);

      const data: WebSectionTrackingData = {
        section: 'S_Billing',
        next_section: '',
        operation,
        errorMessage: '',
      };
      eventBus().emit(Events.Type.SaveWebSectionTracking, data);

      /** Show mail sent popup */
      const msg = 'Mail sent successfully';
      this.deps.popupService.showPopup('package-selection-email-success-popup', msg, 'Ok', '');
      return mailType + ' mail sent';
    } else {
      const msg = 'Mail was not sent';
      this.deps.popupService.showPopup('package-selection-email-fail-popup', msg, 'Ok', '');
      throw 'no mails sent';
    }
  }

  public async sendQuoteMail(qId: string) {
    this.sendMail({ mailType: 'quotenotFromPortal', isLockScreen: true, operation: 'sendBillingQuote', qId });
  }

  public async sendPaymentLinkMail(qId: string) {
    this.sendMail({ mailType: 'paynotFromPortal', isLockScreen: false, operation: 'sendPaymentLink', qId });
  }

  public async sendRenewalMail(qId: string) {   
    const sendMailResponse = await this.sendMail({
      mailType: 'renewalnotFromPortal',
      isLockScreen: false,
      operation: 'sendRenewalQuote',
      qId,
    });
    if (sendMailResponse === 'renewalnotFromPortal mail sent') {
      // refresh the page after 1 second
      setTimeout(() => { eventBus().emit(Events.Type.GoToWebsite, { url: window.location.href }); }, 1000);
    }    
  }
}

MailService.define();
